import { Button, type NativeButtonProps } from '@ff-it/ui';
import { ForwardedRef, forwardRef, type ReactElement } from 'react';

export const AddButton = forwardRef(function AddButton(
  { children, variant = 'secondary', icon = 'plus', size = 'sm', ...props }: Partial<NativeButtonProps>,
  ref: ForwardedRef<HTMLButtonElement>,
): ReactElement {
  return (
    <Button variant={variant} type="button" size={size} icon={icon} {...props} ref={ref}>
      {children}
    </Button>
  );
});
